import React from 'react';
import ATable from '../../common/table';
import { permissioned } from '../../common/permissionedHoc';

const ScriptsTable = (props) => {
    
    
    const columns = [{
        header: "S/N",
        width: 50,
        render :  row => (<div>{row.viewIndex + 1}</div>)
    }, 
    {
        header: "Name",
        accessor: "name"
    },
    {
        header: "Last Updated",
        accessor: "lastUpdatedOn"
    }
    ];
    return (
            <ATable
                className="-striped -highlight"
                tableData={props.scripts}
                columns={columns}
                loading={props.loading}
                onRowClick={props.onRowClick} />
    )
};

export default permissioned(ScriptsTable);


// WEBPACK FOOTER //
// ./src/components/admin/scripts/scriptsTable.js